import axios from "axios";

export default {
  state: {
    authPhone: '',
    authCode: null,
    authTokens: null,
    authPassword: null,
    authCodeLoading: false,
  },
  getters: {
    getAuthToken(state:any): string {
      return `Bearer ${state.tokens.access}`
    },
    isAuth(state:any) {
      return !!state.tokens
    }
  },
  mutations: {},
  actions: {
    async authByCode(context: any) {
      type sendData = {
        username: string,
        password: string,
        salon_id: number,
        code?: string,
      }
      const data:sendData = {
        username: context.state.authPhone.replace('+', '').replace(/\s+/g, ''),
        password: context.state.authPassword,
        salon_id: context.rootState.salonId,
      };

      if (context.state.authCode) {
        data.code = context.state.authCode.replace(/\s+/g, '')
      }
      context.state.authCodeLoading = true
      return await axios({
        url: 'https://qoob.store/api/v1/signup/',
        method: "POST",
        data: data,
      }).then(response => {
        context.state.authCodeLoading = false
        return response
      }) 
    },
  },
};
